/** Normalize Meta Graph `picture` / `picture{url}` shapes to a single CDN URL string. */
export function metaGraphPagePictureUrl(
  picture:
    | string
    | { url?: string; data?: { url?: string } }
    | null
    | undefined
): string {
  if (typeof picture === "string") {
    return picture.trim();
  }
  if (!picture || typeof picture !== "object") {
    return "";
  }
  const directUrl = picture.url?.trim();
  if (directUrl) {
    return directUrl;
  }
  return picture.data?.url?.trim() ?? "";
}
